import axios from 'axios';

const api = axios.create({
    baseURL: 'https://cop30painel.colab208.com.br/api',
})

export default api;